
/* injects from baggage-loader */

export const letters = "abcdefghijklmnopqrstuvwxyz";
export const rowsNumbers = "54321"

export const successText = [
    'Estamos quase concluindo esta <b>missão</b>, mas parece que <b>outro</b> tamanduá resolveu percorrer o <b>caminho</b> até o <b>formigueiro</b>. Vamos ver se ele consegue <b>chegar</b> até lá?',
]
export const failText = 'Parece que você se <b>confundiu</b>. <br> Tente <b>observar</b> melhor o trajeto e <b>conferir</b> novamente as respostas <b>indicadas</b> em vermelho!'

export function AnswerItemPosition(item){
    return `Em qual posição se encontra o <b> ${ item.label }</b>?`
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/quiz-tamandua-b/quiz-tamandua-b.const.js